import {Injectable} from '@angular/core';
import {PostMessageSubscriberModel} from '../models/post-message/post-message-subscriber.model';
import {PostMessageSubscribeTypeEnum} from '../enums/post-message-subscribe-type.enum';
import {DialogService} from './dialog.service';

@Injectable({
  providedIn: 'root'
})
export class PostMessageSubscriberService {

  private readonly subscribers: PostMessageSubscriberModel[] = [];

  constructor(
    private readonly dialogService: DialogService,
  ) {
    this.setupListener()
  }

  public subscribe(type: PostMessageSubscribeTypeEnum, callback: (data: any) => void): void {
    if (this.subscribers.some((subscriber) => subscriber.key === type)) {
      throw new Error(`Already subscribed to ${type}`);
    } else {
      this.subscribers.push({key: type, callback});
    }
  }

  public unsubscribe(type: PostMessageSubscribeTypeEnum): void {
    const index = this.subscribers.findIndex((subscriber) => subscriber.key === type);
    if (index !== -1) {
      this.subscribers.splice(index, 1);
    } else {
      console.info(`Not subscribed to ${type} found.`);
    }
  }

  private setupListener(): void {
    window.addEventListener("message", (event) => {
      const eventData = event.data;
      const subscriber = this.subscribers.find((subscriber) => subscriber.key === eventData.type);
      if (eventData.type === PostMessageSubscribeTypeEnum.ERROR) {
        if (eventData.content.status && eventData.content.message) {
          this.dialogService.openExceptionDialog({
            data: {
              title: eventData.content.message.messageSubject,
              message: eventData.content.message.messageBody
            }
          });
        } else {
          this.dialogService.openExceptionDialog({
            data: {
              title: 'exceptions.asyncRequest.modal.subject',
              message: 'exceptions.asyncRequest.modal.body'
            }
          });
        }
      } else if (subscriber) {
        subscriber.callback(eventData.content);
      } else {
        console.info(`No subscriber found for type ${eventData.type}`);
      }
    });
  }
}
